"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Disc3, Music, PartyPopper } from "lucide-react";
export default function ServicesWeOffer() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const services = [{
    icon: Music,
    title: "Wedding DJ Services",
    description: "Unforgettable musical experiences for your special day with customized playlists and professional sound.",
    color: "bg-dark-background",
    textColor: "text-foreground-dark",
    delay: "delay-[0ms]"
  }, {
    icon: Disc3,
    title: "Corporate Event DJ",
    description: "Professional entertainment for corporate functions, conferences, and team-building events that keep energy high.",
    color: "bg-dark-background",
    textColor: "text-foreground-dark",
    delay: "delay-[150ms]"
  }, {
    icon: PartyPopper,
    title: "Private Party DJ",
    description: "Fun, interactive performances for birthdays, anniversaries, and celebrations that get everyone dancing.",
    color: "bg-dark-background",
    textColor: "text-foreground-dark",
    delay: "delay-[300ms]"
  }];
  const refs = [card1Ref, card2Ref, card3Ref];
  const visibles = [card1Visible, card2Visible, card3Visible];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground sm:text-5xl">
            Services We Offer
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            Professional DJ services tailored to make your event unforgettable
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`group transform transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${visibles[i] ? "translate-x-0 opacity-100" : i === 0 ? "-translate-x-12 opacity-0" : i === 2 ? "translate-x-12 opacity-0" : "translate-y-12 opacity-0"} ${service.delay}`}>
                <Card className="h-full overflow-hidden border-2 border-border shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-2 hover:shadow-strong">
                  <div className={`${service.color} flex h-40 items-center justify-center transition-all duration-[var(--duration-slow)] group-hover:animate-pulse`}>
                    <Icon className={`h-20 w-20 ${service.textColor}`} strokeWidth={1.5} />
                  </div>
                  <CardHeader className="border-b">
                    <CardTitle className="text-xl">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="pt-6">
                    <CardDescription className="text-base leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}